import { useState } from 'react';

import { Box, Flex, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import StarIcon from '~/assets/icons/star.svg?react';
import { useArtistFoundSelector } from '~/store/slices/search-hook';

function Artists() {
  const { t } = useTranslation('common');
  const artists = useArtistFoundSelector();
  const [maxDisplay, setMaxDisplay] = useState(4);

  return (
    <Stack minW='100%'>
      <Flex direction='row' justifyContent='space-between' minW='100%' mb={3}>
        <Text fontSize='18px' fontWeight='600'>
          {t('artists')}
        </Text>
        {maxDisplay === Infinity ? (
          <Text
            fontSize='13px'
            textDecoration='underline'
            cursor='pointer'
            onClick={() => setMaxDisplay(6)}
          >
            {t('actions.seeLess')}
          </Text>
        ) : (
          <Text
            fontSize='13px'
            textDecoration='underline'
            cursor='pointer'
            onClick={() => setMaxDisplay(Infinity)}
          >
            {t('actions.allArtists')}
          </Text>
        )}
      </Flex>

      <SimpleGrid columns={2} spacing={5}>
        {artists.slice(0, maxDisplay).map((artist, index) => (
          <Flex key={index} direction='row' alignItems='center'>
            <Box mx={3}>
              <StarIcon />
            </Box>

            <Stack spacing={0} w='300px' overflow='hidden'>
              <Text
                fontSize='16px'
                fontWeight='600'
                overflow='hidden'
                whiteSpace='nowrap'
                textOverflow='ellipsis'
              >
                {artist}
              </Text>
              <Text fontSize='14px' fontWeight='200'>
                {t('artist')}
              </Text>
            </Stack>
          </Flex>
        ))}
      </SimpleGrid>
    </Stack>
  );
}

export default Artists;
